module.exports = __webpack_public_path__ + "static/img/title_en@2x.e3ebe4a.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/UID/title_en@2x.png
// module id = +ldo
// module chunks = 1